// src/utils/categoryRules.js

export const DISCIPLINES = {
  JUDO: "Judo",
  JUJITSU: "Ju-Jitsu",
  NEWAZA: "Ne-Waza",
};

export function getSeasonStartYear(baseDate = new Date()) {
  const month = baseDate.getMonth(); // 0 = janvier, 11 = décembre
  return month >= 8 ? baseDate.getFullYear() : baseDate.getFullYear() - 1;
}

export function normalizeDiscipline(discipline = "Judo") {
  const value = String(discipline).trim().toLowerCase();

  if (
    [
      "Jujitsu Combat",
      "jujitsu combat",
      "JJB",
    ].includes(value)
  ) {
    return DISCIPLINES.JUJITSU;
  }

  if (["Ne-Waza", "ne-waza", "newaza", "ne waza"].includes(value)) {
    return DISCIPLINES.NEWAZA;
  }

  return DISCIPLINES.JUDO;
}

export function isFemale(gender) {
  const value = String(gender || "").trim().toLowerCase();
  return ["f", "féminin", "feminin", "female"].includes(value);
}

export function buildAgeMappings(seasonStartYear) {
  return {
    [DISCIPLINES.JUDO]: {
      France: [
        { name: "Éveil", range: [seasonStartYear - 5, seasonStartYear - 3] },
        {
          name: "Mini-Poussin(e)",
          range: [seasonStartYear - 7, seasonStartYear - 6],
        },
        {
          name: "Poussin(e)",
          range: [seasonStartYear - 9, seasonStartYear - 8],
        },
        {
          name: "Benjamin(e)",
          range: [seasonStartYear - 11, seasonStartYear - 10],
        },
        { name: "Minime", range: [seasonStartYear - 13, seasonStartYear - 12] },
        {
          name: "Cadet(te)",
          range: [seasonStartYear - 16, seasonStartYear - 14],
        },
        { name: "Junior", range: [seasonStartYear - 19, seasonStartYear - 17] },
        { name: "Sénior", range: [seasonStartYear - 29, seasonStartYear - 20] },
        { name: "Vétéran", range: [0, seasonStartYear - 30] },
      ],
      Belgique: [
        { name: "U7", range: [seasonStartYear - 5, seasonStartYear - 3] },
        { name: "U9", range: [seasonStartYear - 7, seasonStartYear - 6] },
        { name: "U11", range: [seasonStartYear - 9, seasonStartYear - 8] },
        { name: "U13", range: [seasonStartYear - 11, seasonStartYear - 10] },
        { name: "U15", range: [seasonStartYear - 13, seasonStartYear - 12] },
        { name: "U18", range: [seasonStartYear - 16, seasonStartYear - 14] },
        { name: "U21", range: [seasonStartYear - 19, seasonStartYear - 17] },
        { name: "Sénior", range: [seasonStartYear - 29, seasonStartYear - 20] },
        { name: "Vétéran", range: [0, seasonStartYear - 30] },
      ],
    },

    // Ju-Jitsu Fighting / Combat
    // Basé sur ta capture pour U10 -> U18
    [DISCIPLINES.JUJITSU]: {
      France: [
        { name: "U10", range: [seasonStartYear - 8, seasonStartYear - 7] },   // ex 2017/2018
        { name: "U12", range: [seasonStartYear - 10, seasonStartYear - 9] },  // ex 2015/2016
        { name: "U14", range: [seasonStartYear - 12, seasonStartYear - 11] }, // ex 2013/2014
        { name: "U16", range: [seasonStartYear - 14, seasonStartYear - 13] }, // ex 2011/2012
        { name: "U18", range: [seasonStartYear - 16, seasonStartYear - 15] }, // ex 2009/2010
        { name: "Junior", range: [seasonStartYear - 18, seasonStartYear - 17] },
        { name: "Sénior", range: [0, seasonStartYear - 19] },
      ],
    },

    // Ne-Waza : le livret vise cadets / juniors / séniors
    [DISCIPLINES.NEWAZA]: {
      France: [
        { name: "Cadet(te)", range: [seasonStartYear - 16, seasonStartYear - 14] },
        { name: "Junior", range: [seasonStartYear - 18, seasonStartYear - 17] },
        { name: "Sénior", range: [0, seasonStartYear - 19] },
      ],
    },
  };
}

const judoFrance = {
  "Benjamin(e)": [26, 30, 34, 38, 42, 46, 50, 55, 60, 66],
  Minime: [34, 38, 42, 46, 50, 55, 60, 66, 73],
  "Cadet(te)": [46, 50, 55, 60, 66, 73, 81, 90],
  Junior: [55, 60, 66, 73, 81, 90, 100],
  Sénior: [60, 66, 73, 81, 90, 100],
  Vétéran: [60, 66, 73, 81, 90, 100],
  "Benjamin(e)F": [28, 32, 36, 40, 44, 48, 52, 57, 63],
  MinimeF: [36, 40, 44, 48, 52, 57, 63, 70],
  "Cadet(te)F": [40, 44, 48, 52, 57, 63, 70],
  JuniorF: [44, 48, 52, 57, 63, 70, 78],
  SéniorF: [48, 52, 57, 63, 70, 78],
  VétéranF: [48, 52, 57, 63, 70, 78],
};

const judoBelgique = {
  U11: [26, 30, 34, 38, 42],
  U13: [30, 34, 38, 42, 46, 50],
  U15: [34, 38, 42, 46, 50, 55, 60],
  U18: [46, 50, 55, 60, 66, 73],
  U21: [55, 60, 66, 73, 81],
  Sénior: [60, 66, 73, 81, 90, 100],
  Vétéran: [60, 66, 73, 81, 90, 100],
  U11F: [28, 32, 36, 40],
  U13F: [32, 36, 40, 44],
  U15F: [36, 40, 44, 48, 52],
  U18F: [44, 48, 52, 57, 63],
  U21F: [48, 52, 57, 63, 70],
  SéniorF: [48, 52, 57, 63, 70, 78],
  VétéranF: [48, 52, 57, 63, 70, 78],
};

// Ta capture écran
const juJitsuFrance = {
  U10F: [20, 22, 25, 28, 32, 36, 40],
  U10: [22, 25, 28, 32, 36, 40, 44],

  U12F: [22, 25, 28, 32, 36, 40, 44, 48],
  U12: [25, 28, 32, 36, 40, 44, 48, 52],

  U14F: [25, 28, 32, 36, 40, 44, 48, 52, 57],
  U14: [32, 36, 40, 44, 48, 52, 56, 62, 69],

  U16F: [32, 36, 40, 44, 48, 52, 57, 63],
  U16: [40, 44, 48, 52, 56, 62, 69, 77],

  U18F: [40, 44, 48, 52, 57, 63, 70],
  U18: [48, 52, 56, 62, 69, 77, 85],

  // Adultes / grands âges du livret
  JuniorF: [45, 48, 52, 57, 63, 70],
  Junior: [56, 62, 69, 77, 85, 94],
  SéniorF: [45, 48, 52, 57, 63, 70],
  Sénior: [56, 62, 69, 77, 85, 94],
};

// Ici je pars sur les catégories du livret
const neWazaFrance = {
  "Cadet(te)F": [40, 44, 48, 52, 57, 63, 70],
  "Cadet(te)": [48, 52, 56, 62, 69, 77, 85],
  JuniorF: [45, 48, 52, 57, 63, 70],
  Junior: [56, 62, 69, 77, 85, 94],
  SéniorF: [45, 48, 52, 57, 63, 70],
  Sénior: [56, 62, 69, 77, 85, 94],
};

export const weightCategoriesByDiscipline = {
  [DISCIPLINES.JUDO]: {
    France: judoFrance,
    Belgique: judoBelgique,
  },
  [DISCIPLINES.JUJITSU]: {
    France: juJitsuFrance,
  },
  [DISCIPLINES.NEWAZA]: {
    France: neWazaFrance,
  },
};